import React from 'react'
import { DoneAll } from '@mui/icons-material'
import { MenuItem, Typography } from '@mui/material'

import { EVENT_CODE_GANTT } from '@constants'
import { AutocompleteOption, SelectOption } from '@types'

import { GanttActionType } from '@gantt/components/GanttCreateOrEdit'
import { isCellTarget, isSegmentTarget } from '@gantt/helpers/helpers'

const isTargetIncludesValue = (target: any, value: string | number): boolean => {
  if (!target) return false

  if (Array.isArray(target)) {
    return target.some(item => {
      if (typeof item === 'object' && item !== null && 'id' in item) {
        return item.id === value
      }

      return item === value
    })
  }

  if (typeof target === 'object' && target !== null && 'id' in target) {
    return target.id === value
  }

  return target === value
}

export const getSelectOptionDisabledTarget = (
  option: SelectOption | AutocompleteOption,
  list: GanttActionType[],
  id?: string | number,
  actionCode?: string,
  eventCode?: string
) => {
  return Boolean(
    list.find(
      event =>
        isTargetIncludesValue(event.target, option.id) &&
        event.id !== id &&
        event.actionCode === actionCode &&
        event.eventCode === eventCode &&
        (!isCellTarget(event.eventCode) || !isSegmentTarget(event.eventCode))
    )
  )
}

export const getSelectOptionDisabledEvent = (
  option: SelectOption,
  list: GanttActionType[],
  id?: string | number
) => {
  return Boolean(
    list.find(
      event =>
        event.eventCode === option.name &&
        event.id !== id &&
        !isCellTarget(event.eventCode) &&
        !isSegmentTarget(event.eventCode)
    )
  )
}

export const GanttActionOptionSelectTarget = (props: {
  option: SelectOption
  list: GanttActionType[]
}) => {
  const { option, list } = props
  const isAlreadyUsed = list.find(
    event =>
      isTargetIncludesValue(event.target, option.id) &&
      (isCellTarget(event.eventCode) || isSegmentTarget(event.eventCode))
  )

  if (isAlreadyUsed) {
    return (
      <>
        <DoneAll sx={{ fontSize: '0.9rem', position: 'absolute', left: 2 }} />
        <Typography ml={1}> {option.name}</Typography>
      </>
    )
  }

  return <>{option.name}</>
}

export const GanttActionOptionAutocompleteTarget = (props: {
  option: AutocompleteOption
  list: GanttActionType[]
  eventCode: EVENT_CODE_GANTT
  currentActionId?: string | number
  autocompleteProps: React.HTMLAttributes<HTMLLIElement>
}) => {
  const { option, list, eventCode, autocompleteProps, currentActionId } = props
  const isAlreadyUsed = list.find(
    event =>
      isTargetIncludesValue(event.target, option.id) &&
      eventCode === event.eventCode &&
      event.id !== currentActionId
  )

  return (
    <MenuItem {...autocompleteProps}>
      {isAlreadyUsed && <DoneAll sx={{ fontSize: '0.9rem', position: 'absolute', left: 2 }} />}
      <Typography ml={1}>{option.label}</Typography>
    </MenuItem>
  )
}

export const GanttActionOptionSelectEvent = (props: {
  option: SelectOption
  list: GanttActionType[]
}) => {
  const { list, option } = props
  const isAlreadyUsed = list.find(
    event => event.eventCode === option.name && !isCellTarget(event.eventCode)
  )

  if (isAlreadyUsed) {
    return (
      <>
        <DoneAll sx={{ fontSize: '0.9rem', position: 'absolute', left: 2 }} />
        <Typography ml={1}> {option.name}</Typography>
      </>
    )
  }

  return <>{option.name}</>
}
